import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-target", "aria-controls"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "float-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["id", "aria-labelledby"]
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "items-input p-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, "１年以内返済予定", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_setting_panel = _resolveComponent("setting-panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "card-header",
      id: 'kariirekin-long-item-header-' + _ctx.item.item.id
    }, [
      _createElementVNode("button", {
        class: "btn btn-link",
        type: "button",
        "data-toggle": "collapse",
        "data-target": '#kariirekin-long-item-' + _ctx.item.item.id,
        "aria-expanded": "false",
        "aria-controls": 'kariirekin-long-item-' + _ctx.item.item.id
      }, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.headerName)
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickedUpItem && _ctx.onClickedUpItem(...args)))
            }, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.isLast)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-link",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickedDownItem && _ctx.onClickedDownItem(...args)))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickedTrashItem && _ctx.onClickedTrashItem(...args)))
        }, _hoisted_10)
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: 'kariirekin-long-item-' + _ctx.item.item.id,
      class: "collapse",
      "aria-labelledby": 'kariirekin-long-item-header-' + _ctx.item.item.id
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", {
              for: 'item-name-' + _ctx.item.item.id
            }, "借入先", 8, _hoisted_15),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.itemName }]),
              id: 'item-name-' + _ctx.item.item.id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.itemName) = $event)),
              placeholder: "借入先",
              onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
            }, null, 42, _hoisted_16), [
              [_vModelText, _ctx.values.itemName]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.itemName)
            }, null, 8, _hoisted_17)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_setting_panel, {
            class: "mt-3",
            "response-setting-item": _ctx.item.item.afterYearsSetting,
            "panel-name": "afterYears",
            onUpdateSettingItem: _ctx.onUpdateKmk
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_18,
          _createVNode(_component_setting_panel, {
            class: "mt-3",
            "response-setting-item": _ctx.item.item.withinOneYearSetting,
            "panel-name": "withinOneYear",
            onUpdateSettingItem: _ctx.onUpdateKmk
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ])
    ], 8, _hoisted_11)
  ]))
}